import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import { useRouter } from "next/router";
import { PDPBreakPoints, Style } from "@/constants/BreakPoints";
import { useEffect, useState } from "react";
import ImagePreview from "./FancyBox";
import ProductLabel from "../Helpers/ProductLabel";
import ThreeSixtyIcon from "../icons/ThreeSixtyIcon";
import Product360View from "./Product360View";
import { getImages360ViewBySku } from "@/services/elasticsearch/getProduct";
import useSWR from "swr";
import ImageLightBox from "./Lightbox";
import ZoomInIcon from "../icons/ZoomInIcon";
import { validateImgSrc } from "@/utils/global";
import NextImage from "../NextImage";

function Album({ product, images }) {
  const [currentSlide, setCurrentSlide] = useState(images?.at(0) || {});
  const [isShow360, setIsShow360] = useState(false);
  const [isPreviewOpen, setPreviewOpen] = useState(false);
  const [openFancybox, setOpenFancybox] = useState(false);

  const { locale } = useRouter();

  useEffect(() => {
    setCurrentSlide(images?.at(0));
  }, [images]);
  const { data: dataOf360ImagesView } = useSWR(
    product?.is_360_view ? `${product?.is_360_view}-${locale}-` : null,
    async () => {
      const res360 = await getImages360ViewBySku(product?.sku, undefined);
      return res360?.data?.data || [];
    },
    {
      populateCache: true,
    }
  );

  // Image

  // const ImageCustomizationInstanse = new ImageCustomization;

  // const getTheFullURL = (imageSize) => {
  //   ImageCustomizationInstanse.setQuality(50)
  //   const handleCloudOptions = `cdn-cgi/image/${ImageCustomizationInstanse.width ? `w=${ImageCustomizationInstanse.width}` : `h=${ImageCustomizationInstanse.height}`},format=${ImageCustomizationInstanse.format},quality=${imageSize == "main" ? "75" : ImageCustomizationInstanse.quality},fit=${ImageCustomizationInstanse.fit}`
  //   return `${process.env.NEXT_PUBLIC_IMAGE_BASEURL}/${handleCloudOptions}/${ImageCustomizationInstanse.getRoutePDP("product")}`
  // }

  const LabelImages = product?.label
    ?.filter(
      (el) =>
        el &&
        el?.status === "1" &&
        new Date(el?.active_from) < new Date() < new Date(el?.active_to)
    )
    ?.map((label, i) => (
      <ProductLabel
        label={label}
        fromTopTen={false}
        key={i}
        fromCategory={false}
      />
    ));

  return (
    <div className="relative col-span-6 max-md:border py-2 max-md:p-0 max-[991px]:col-span-12">
      {isPreviewOpen && (
        <ImagePreview
          imageUrl={currentSlide?.image || images[0].image}
          onClose={setPreviewOpen}
        />
      )}
      <div className="sticky p-2 bg-white rounded-md max-md:p-0 top-2">
        <div
          className={`relative border rounded-md ${
            images?.length === 1
              ? "block"
              : "max-[570px]:hidden max-[768px]:hidden max-[991px]:block"
          }`}
        >
          {isShow360 ? (
            <div className="max-[991px]:w-full max-[991px]:h-[400px] w-full h-[500px] mx-auto flex items-center justify-center overflow-hidden">
              <Product360View
                images={dataOf360ImagesView?.map(
                  (item) =>
                    `${process.env.NEXT_PUBLIC_IMAGE_BASEURL}/media/${item?.image_path}`
                )}
              />
            </div>
          ) : (
            <NextImage
              onClick={() => {
                setPreviewOpen(true);
              }}
              src={validateImgSrc(currentSlide?.image || images?.at(0)?.image)}
              className="max-[991px]:w-[300px] max-[991px]:h-[400px] w-[600px] h-[500px] object-contain mx-auto cursor-pointer"
              width={500}
              height={500}
              alt={product?.name}
              priority
              loading="eager"
            />
          )}

          {LabelImages}

          <button
            type="button"
            className={`absolute top-3 ${
              locale === "en" ? "right-3" : "left-3"
            } text-red bg-gray-100 rounded-full p-2 shadow-md`}
          >
            <ZoomInIcon
              onClick={() => setOpenFancybox(true)}
              className="size-6 max-[768px]:size-8"
            />
          </button>
        </div>
        {images && images?.length > 1 ? (
          <div className="relative pb-3 my-3 border-none max-[570px]:border max-[991px]:border">
            <Swiper
              dir="ltr"
              spaceBetween={15}
              modules={[Pagination]}
              pagination={{ enabled: false }}
              style={Style}
              breakpoints={PDPBreakPoints}
              className="h-[100px] max-[991px]:h-[380px] relative"
            >
              {product?.is_360_view && (
                <SwiperSlide>
                  <div
                    onClick={() => setIsShow360((prev) => !prev)}
                    className="flex items-center justify-center w-full h-full border rounded-md cursor-pointer max-[991px]:mx-auto"
                  >
                    <ThreeSixtyIcon width={40} height={40} />
                  </div>
                </SwiperSlide>
              )}

              {images?.map((slide, idx) => (
                <SwiperSlide
                  key={idx}
                  className="relative hover:cursor-pointer"
                >
                  <div
                    className={`hidden max-[768px]:block absolute top-5  end-3 z-40`}
                  ></div>
                  <NextImage
                    onClick={() => setCurrentSlide(images[idx])}
                    src={validateImgSrc(slide.image)}
                    width={150}
                    height={150}
                    alt={product?.name}
                    priority
                    loading="eager"
                    className="h-full w-full object-contain rounded-md max-[991px]:w-[600px] max-[991px]:h-[350px] max-[991px]:mx-auto max-[570px]:border-none max-[991px]:border xl:border max-[1200px]:border 2xl:border"
                  />

                  <div className="hidden max-[768px]:block">{LabelImages}</div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : null}
      </div>
      <ImageLightBox
        images={images}
        open={openFancybox}
        close={setOpenFancybox}
        customClassName="PDPFancyBoxContainer"
      />
    </div>
  );
  //  : (
  //   <div className="flex items-center justify-center col-span-6 py-2 text-xl uppercase max-[991px]:col-span-12">
  //     Loading...
  //   </div>
  // );
}

export default Album;
